import { Injectable } from '@angular/core';
import { AppConfig } from '../../app-services/config/config.app';
import { HttpClient } from '@angular/common/http';
import { AbstractEndpoints } from '../endpoints/endpoints.service.abstract';
import { map, Observable } from 'rxjs';
import { ModelResponsePageViews } from '../../models/http-responses/page-views-result.model';
import { ModelPageViewEntry } from '../../models/campaign-insights/page-views.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceCampaignInsights {

  constructor(private readonly endpoints: AbstractEndpoints, private readonly http: HttpClient, private readonly appConfig: AppConfig) { }

  getPageViews(url: string, startDate: Date, endDate: Date): Observable<ModelPageViewEntry[]> {
    return this.http.get(this.endpoints.campaignInsights.getPageViews(url, startDate, endDate)).pipe(map((result: any) => {
      return this.mapPageViewData(result as ModelResponsePageViews);
    }));
  }

  private mapPageViewData(data: ModelResponsePageViews): ModelPageViewEntry[] {
    const pageViewsArray: ModelPageViewEntry[] = [];
    const columns = data.columns.map((col: any) => col.name);

    data.rows.forEach((row: any[]) => {
      const pageView: any = {};
      row.forEach((value: any, index: number) => {
        pageView[columns[index]] = value;
      });
      pageViewsArray.push(pageView as ModelPageViewEntry);
    });

    return pageViewsArray;
  }
}
